/*
PW Sortable Dropdown Menu
*/
import _ from 'lodash'
import React from 'react'
import T from 'prop-types'
import ItemList from './ItemList'
import ItemPreview from './ItemPreview'

class SortableMenu extends React.Component {
  static displayName = 'SortableMenu'

  static propTypes = {
    allItems: T.arrayOf(
      T.shape({
        id: T.string.isRequired,
        display: T.string.isRequired
      })
    ), // Array of all possible item options
    allowDisable: T.bool,
    defaultItemIds: T.arrayOf(T.string), // Ordered array of IDs
    touchBackendEnabled: T.bool // If true, will insert manual ItemPreview component on drag
  }

  static defaultProps = {
    allItems: [],
    defaultItemIds: [],
    allowDisable: true, // Pass false for a simple sortable list
    touchBackendEnabled: false
  }

  constructor(props) {
    super(props)
    const { defaultItemIds, allItems } = props

    this.state = {
      activeItems: _(defaultItemIds || [])
        .map(optId => _.find(allItems, { id: optId }))
        .compact()
        .value(),
      inactiveItems: _.filter(
        allItems || [],
        itm => defaultItemIds.indexOf(itm.id) === -1
      )
    }

    this.moveItem = this.moveItem.bind(this)
    this.findItem = this.findItem.bind(this)
    this.getActiveItems = this.getActiveItems.bind(this)
  }

  moveItem(id, atIndex, toActiveList) {
    const { item, index, isActive } = this.findItem(id)

    const toListId = toActiveList ? 'activeItems' : 'inactiveItems'
    const fromListId = isActive ? 'activeItems' : 'inactiveItems'

    if (toListId === fromListId) {
      // Moving within same list
      const list = _.cloneDeep(this.state[toListId])
      list.splice(index, 1)
      list.splice(atIndex, 0, item)
      const _newState = {}
      _newState[toListId] = list
      this.setState(_newState)
    } else {
      const fromList = _.cloneDeep(this.state[fromListId])
      const toList = _.cloneDeep(this.state[toListId])
      fromList.splice(index, 1)
      toList.splice(atIndex, 0, item)
      const _newState = {}
      _newState[fromListId] = fromList
      _newState[toListId] = toList
      this.setState(_newState)
    }
  }

  findItem(id) {
    const isActive = !!_.find(this.state.activeItems, { id: id })
    const items = isActive ? this.state.activeItems : this.state.inactiveItems
    const item = items.filter(c => c.id === id)[0]

    return {
      item,
      isActive,
      index: items.indexOf(item)
    }
  }

  // Getter for owner components
  getActiveItems() {
    return this.state.activeItems
  }

  render() {
    const { activeItems, inactiveItems } = this.state
    return (
      <div className="sortable_menu">
        <ItemList
          findItem={this.findItem}
          items={activeItems}
          listId="active"
          moveItem={this.moveItem}
          touchBackendEnabled={this.props.touchBackendEnabled}
        />
        <ItemList
          findItem={this.findItem}
          items={inactiveItems}
          listId="inactive"
          moveItem={this.moveItem}
          touchBackendEnabled={this.props.touchBackendEnabled}
        />
        {this.props.touchBackendEnabled
          ? <ItemPreview findItem={this.findItem} key="__preview" />
          : null}
      </div>
    )
  }
}

export default SortableMenu
